function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M26.041 5.833h-3.118l-.867-2.166C21.166 1.439 19.04 0 16.641 0h-6.615C7.627 0 5.501 1.44 4.61 3.667l-.867 2.166H.626c-.407 0-.706.383-.607.777l.313 1.25c.069.278.319.473.606.473h1.045c-.7.611-1.15 1.5-1.15 2.5v2.5c0 .84.321 1.598.834 2.184v2.816c0 .92.746 1.667 1.666 1.667H5c.92 0 1.667-.746 1.667-1.667v-1.666H20v1.666c0 .92.746 1.667 1.667 1.667h1.666c.92 0 1.667-.746 1.667-1.667v-2.816c.512-.586.833-1.344.833-2.184v-2.5c0-1-.45-1.889-1.15-2.5h1.046c.287 0 .537-.195.606-.473l.313-1.25c.098-.394-.2-.777-.607-.777zM7.705 4.905c.38-.95 1.299-1.572 2.321-1.572h6.615c1.022 0 1.941.623 2.321 1.572L20 7.5H6.667l1.038-2.595zM5 13.323c-1 0-1.667-.665-1.667-1.662C3.333 10.665 4 10 5 10s2.5 1.495 2.5 2.492c0 .997-1.5.83-2.5.83zm16.667 0c-1 0-2.5.166-2.5-.83 0-.998 1.5-2.493 2.5-2.493s1.666.665 1.666 1.661c0 .997-.666 1.662-1.666 1.662z",
  transform: "translate(-210 -441) translate(210 441)"
}))));

function SvgCarFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarFront);
export default __webpack_public_path__ + "static/media/car-front.e497df66.svg";
export { ForwardRef as ReactComponent };